import API_URLS from '@/api/API_URLS.js';
import { httpPost } from '@/api/request';
import { httpGet } from '../request';
export const appointProduct = params => httpPost(API_URLS.PRODUCT_APPOINTMENT, params);
export const getNewsList111 = params => httpPost(API_URLS.NEWS_LIST, params);
export const getCategoryByGroupType = params => httpPost(API_URLS.GROUP_TYPE, params);
export const getProduct = params => httpPost(API_URLS.GROUP_LIST, params);
export const fastContract = params => httpPost(API_URLS.FAST_CONTRACT, params);
export const getSkill = params => httpGet('https://mcp.myhexin.com/mcp-market/api/v1/skills/square', params);